'use client';

import type { UserBike } from 'models/shared';
import { createContext, useContext } from 'react';

/**
 * Sets or clears the vehicle a products page is filtered by, the way the
 * vehicle bar does. Going through it rather than the url keeps the bar's
 * remembered bike in step: a bike taken off only through the url is put back
 * by the bar on the next render.
 */
export const VehicleFilterContext = createContext<
  ((bike: UserBike | null) => void) | null
>(null);

export const useVehicleFilter = () => useContext(VehicleFilterContext);
